/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiGET} from "./RequestsCore";

/**
 * Returns all the existing roles in the app, without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getRoles() {
    return await apiGET('/api/roles');
}
